import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { openRadioSilenceDialog } from 'console/radio-silence-dialog/actions';
import { preventDefault, useCallbacks, usePartial } from 'shared/hooks/utils';
import { CardTableCell } from '../../style/style-card';
import { useAction } from 'shared/hooks/redux/hooks';
export const RadioSilenceCell = memo(function RadioSilenceCell(props) {
    const { enabled, radio_silence, radio_silence_planned, device_id } = props;
    const text = useMemo(() => radio_silence_planned === true
        ? 'запланировано включение'
        : radio_silence_planned === false
            ? 'запланировано выключение'
            : radio_silence === true
                ? 'включено'
                : radio_silence === false
                    ? 'выключено'
                    : '', [radio_silence_planned, radio_silence]);
    const onClick = useCallbacks([
        preventDefault,
        usePartial(useAction(openRadioSilenceDialog), device_id),
    ]);
    return (_jsx(CardTableCell, { children: enabled ? (_jsx("a", { href: "#", onClick: onClick, children: text })) : (_jsx("span", { children: text })) }));
});
